import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PinnedFavoritesResponse } from '../interfaces/Collapsable-title';

@Injectable({
  providedIn: 'root'
})
export class ReportsStore {
  private readonly _pinnedFavorites$: BehaviorSubject<PinnedFavoritesResponse | null> =
    new BehaviorSubject<PinnedFavoritesResponse | null>(null);
  private readonly STORAGE_KEY = 'pinnedFavoriteReports';

  constructor() {
    let initialValue: PinnedFavoritesResponse | null = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring pinned/favorite reports from sessionStorage', e);
    }

    this._pinnedFavorites$ = new BehaviorSubject<PinnedFavoritesResponse | null>(initialValue);
  }

  get pinnedFavorites$(): Observable<PinnedFavoritesResponse | null> {
    return this._pinnedFavorites$.asObservable();
  }

  set pinnedFavorites(data: PinnedFavoritesResponse | null) {
    if (data) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._pinnedFavorites$.next(data);
  }

  clear(): void {
    this.pinnedFavorites = null;
  }
}
